<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch01"></a><a id="page_1"></a><a href="#/contents#ch01"><b>It Would Take…</b></a></h2>
<p class="noindent"><span>…630 silkworm cocoons to make one silk blouse.</span></p>
<p class="noindent"><span>…a chicken-plucking machine 14 seconds to pluck a whole chicken.</span></p>
<p class="noindent"><span>…a drop of ocean water more than 1,000 years to circulate around the world.</span></p>
<p class="noindent"><span>…a manned rocket ship 70,000 years to reach the next closest solar system.</span></p>
<p class="noindent"><span>…about 540 peanuts to make a 12-ounce jar of peanut butter.</span></p>
<p class="noindent"><span>…a combine harvester nine seconds to harvest enough wheat to make 70 loaves of bread.</span></p>
<p class="noindent"><span>…a car traveling at 75 mph 258 days to drive around one of Saturn’s rings.</span></p>
<p class="noindent"><span>…a year’s worth of corks from all the wine bottled in France to circle the world three times.</span></p>
<p class="noindent"><span>…Pluto 248.53 years to travel around the Sun.</span></p>
<p class="noindent"><span>…every star in the Milky Way to fill an Olympic-size swimming pool (if each star were the size of a grain of salt).</span></p>
<p class="noindent"><span>…the Milky Way about 200 million years to make one revolution.</span></p>
<p class="noindent"><span>…about 600 grapes to make a bottle of wine.</span></p>
<p class="noindent"><span>…70 separate pieces of wood to make a violin.</span></p>
<p class="noindent"><span>…up to six gallons of peanut oil to deep-fry a turkey.</span></p>
<p class="noindent"><span>…only one steer to yield enough ground beef for 1,000 McDonald’s Quarter Pounders.</span></p>
<p class="noindent"><span>…the average American 40 days to earn enough money to pay for a year’s worth of food.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?3082b71c